import JobWorkerNotInterestedReason from "../JobWorkers/JobWorkerNotInterestedReason";

export default class UpdateAnonWorkerJobInviteRequest 
{ 
	interested: boolean;
	notInterestedReason: JobWorkerNotInterestedReason;
}